import React, { useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
// import { Tooltip as ReactTooltip } from 'react-tooltip'
import Copybutton from './Copybutton';
import Snackbar from '@material-ui/core/Snackbar'
 const useStyles = makeStyles( theme =>({

}));



 const MaterialUITable = (props_) => {
  const [isTableClicked, setTableClicked] = useState('');
  const [open, setOpen] = useState(false);

  const classes = useStyles();
  var timestamp = props_.timestamp;
  var date = new Date(timestamp*1000);
  var now = new Date();

  // This is the function we wrote earlier
  async function copyTextToClipboard(text) {
    setOpen(true);
    setTimeout(()=>{
      setOpen(false);
    },1000);
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }


  var units = {
    year  : 24 * 60 * 60 * 1000 * 365,
    month : 24 * 60 * 60 * 1000 * 365/12,
    day   : 24 * 60 * 60 * 1000,
    hour  : 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000
  }


  var rtf = new Intl.RelativeTimeFormat('ko', { numeric: 'auto' });
  var getRelativeTime = (d1, d2 = new Date()) => {
    var elapsed = d1 - d2
  
    // "Math.abs" accounts for both "past" & "future" scenarios
    for (var u in units) 
      if (Math.abs(elapsed) > units[u] || u == 'second') 
        return rtf.format(Math.round(elapsed/units[u]), u)
  }
  
  // test-list of dates to compare with current date
  // [
  //   '10/20/1984',
  //   '10/20/2015',
  //   +new Date() - units.year,
  //   +new Date() - units.month,
  //   +new Date() - units.day,
  //   +new Date() - units.hour,
  //   +new Date() - units.minute,
  //   +new Date() + units.minute*2,
  //   +new Date() + units.day*7,
  // ]
  // .forEach(d => console.log(   
  //   new Date(d).toLocaleDateString(),
  //   new Date(d).toLocaleTimeString(), 
  //   '(Relative to now) →',
  //   getRelativeTime(+new Date(d))
  // ))

  var props = {
      columns: [
          { id: 'markdown', label: 'Markdown' },
          { id: 'show', label: 'Show' },
          // { id: 'icon', label: 'Icon' }
        ], 
        rows: [
          { markdown: `<t:${timestamp}:F>`, show:  date.toLocaleString(undefined, { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })}, 
          { markdown: `<t:${timestamp}:f>`, show: date.toLocaleString( undefined, {month: 'long', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' })},
          { markdown: `<t:${timestamp}:D>`, show: date.toLocaleString(undefined, {month: 'long', day: 'numeric', year: 'numeric', })},
          { markdown: `<t:${timestamp}:d>`, show: date.toLocaleDateString()},
          { markdown: `<t:${timestamp}:t>`, show: date.toLocaleTimeString(undefined, {hour: 'numeric', minute: 'numeric' }),},
          { markdown: `<t:${timestamp}:T>`, show: date.toLocaleTimeString(),},
          { markdown: `<t:${timestamp}:R>`, show: getRelativeTime(date, now)},
        ]
  }
  return (
      <div className="scrollbar-custom"
      style={{
        display:'flex',
        justifyContent:'center',
        alignItems:'center'
      }}>
        <div
          role="table"
          className="dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 lg:rounded-2lg w-[90%] lg:w-[60%] border bg-white text-sm dark:text-white"
        >
          <div className="dark:bg-jacarta-600 bg-jacarta-50 rounded-t-2lg flex" role="row">
            <div className="w-[50%] py-3 px-4" role="columnheader">
              <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                Markdown
              </span>
            </div>
            <div className="w-[50%] py-3 px-4" role="columnheader">
              <span className="text-jacarta-700 dark:text-jacarta-100 w-full overflow-hidden text-ellipsis">
                Time format
              </span>
            </div>
          </div>
          {props.rows.map((item) => {
            const {
              markdown,
              show,
            } = item;
            // console.log(item.category.art);

            return (
              <div key={markdown}>
                <a className="flex transition-shadow hover:shadow-lg" role="row" onClick={()=>{copyTextToClipboard(markdown)}}>
                  <div
                    className="dark:border-jacarta-600 border-jacarta-100 flex w-[50%] items-center border-t py-4 px-4"
                    role="cell"
                  >
                    <span style={{textTransform:'none'}} className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                      {markdown}
                    </span>
                  </div>
                  <div
                    className="dark:border-jacarta-600 border-jacarta-100 flex w-[50%] items-center border-t py-4 px-4"
                    role="cell"
                  >
                    <span className="text-sm font-medium tracking-tight">{show}</span>
                    <span className="ml-1 dark:hidden" data-tippy-content="black">
                    <svg className="icon mr-1 h-4 w-4">
                      <use xlinkHref="/icons.svg#icon-paste"></use>
                    </svg>
                    </span>
                    <span className="ml-1 hidden dark:block" data-tippy-content="white">
                    <svg className="icon mr-1 h-4 w-4">
                      <use xlinkHref="/icons.svg#icon-paste-2"></use>
                    </svg>
                    </span>                    
                  </div>
                </a>
              </div>
            );
          })}
          

        </div>

        <Snackbar
        // anchorOrigin={{ vertical, horizontal }}
        open={open}
        // onClose={handleClose}
        message="Copied."
        // key={vertical + horizontal}
        />
      </div>


    );
  }
  
  export default MaterialUITable;